import { action, observable, runInAction } from 'mobx';

enum PolicyType {
  Privacy,
  TermsAndConditions
}

class PolicyDialogStore {
  @observable open: boolean = false;
  @observable mode: PolicyType | null = null;

  @action.bound
  public onOpen(policyType: PolicyType): void {
    runInAction(() => {
      this.mode = policyType;
      this.open = true;
    });
  }

  @action.bound
  public close(): void {
    this.open = false;
  }
}

export default PolicyDialogStore;
export { PolicyType };
